import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { IoMdImage } from 'react-icons/io';

import { __t } from '@mssgme/shared';
import { LazyImage } from '@mssgme/ui';

import styles from './styles.scss';

export const ProductItem = ({ tag: Tag, product, componentStyle, ...rest }) => (
    <Tag
        className={classNames(styles.root, styles[componentStyle], { [styles.disabled]: !product.published })}
        {...rest}
    >
        <div className={styles.thumbnail}>
            {product.photoUrl && <LazyImage src={product.photoUrl} alt={product.name} />}
            {!product.photoUrl && (
                <div className={styles.emptyPlaceholder}>
                    <IoMdImage size="40%" color="#fff" />
                </div>
            )}
        </div>
        <div className={styles.meta}>
            <span className={styles.title}>{product.name}</span>
            {product.price && (
                <span className={styles.price}>
                    {product.price.formattedDiscount && (
                        <span className={styles.discountPrice}>{product.price.formattedDiscount}</span>
                    )}
                    {product.price.amount === 0 ? (
                        __t('free')
                    ) : (
                        <span className={product.price.formattedDiscount ? styles.lineThrough : null}>
                            {product.price.formatted}
                        </span>
                    )}
                </span>
            )}
        </div>
    </Tag>
);

ProductItem.propTypes = {
    product: PropTypes.object.isRequired,
    componentStyle: PropTypes.string,
    tag: PropTypes.any,
};

ProductItem.defaultProps = {
    tag: 'div',
};
